import { render } from "./editBorough.vue?vue&type=template&id=30c23f50&scoped=true"
import script from "./editBorough.vue?vue&type=script&lang=js"
export * from "./editBorough.vue?vue&type=script&lang=js"

import "./editBorough.vue?vue&type=style&index=0&id=30c23f50&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c23f50"]])

export default __exports__